import { getBaseUrl } from "../hooks/useRequest";

const URL = getBaseUrl()

export const customFetch = ({ params, method, body, onSuccess, onError, contentType, token }) => {
    fetch(URL + params, {
        method: method || 'GET',
        headers: {
            'Content-Type': contentType || 'application/json; charset=UTF-8',
            "Authorization": token
        },
        body,
    }).then(res => {
        if (res.ok) {
            return res.json()
        }
    }).then((data) => {
            if (data.errNo === -4) {
                // token expired or invalid
                window.location.replace("/")
            } else if(data.errNo === 0 || data.Step) {
                onSuccess(data)
            } else if(data.Status) {
                onSuccess(data)

                // special case for time information
            } else if(data.Time !== "" && data.Time !== undefined) {
                onSuccess(data)
            } else {
                if(onError) {
                    onError(data)
                }
            }
        }).catch(err => {
        if(onError) {
            onError(err)
        }
    })
}
